/* =================================================================
   Product description, restructured.

   Shopify hands us one blob: a tagline, a paragraph of prose, then a
   regulatory ingredient dump with E-numbers. Printed as-is it reads like a
   packaging label, which is the opposite of how the rest of the site reads.

   This splits that blob into the three things it actually is - a lede, the
   prose, and the ingredients - and renders the ingredients as chips the way
   the hand-built pages do. The full legal statement is kept verbatim in a
   quiet fine-print block, because dropping E-numbers is not an option.
================================================================= */
(function () {
  'use strict';

  var host = document.querySelector('.description');
  if (!host || host.dataset.done) return;

  var paras = [].slice.call(host.querySelectorAll('p'))
    .map(function (p) { return { el: p, text: (p.textContent || '').trim() }; })
    .filter(function (p) { return p.text; });
  if (!paras.length) return;

  var isIng = function (t) {
    // "Ingredients : ..." or a mix heading like "EVERGREEN MIX:"
    return /ingredients\s*:/i.test(t) || /^[A-Z][A-Z0-9 &'-]{2,}:/.test(t);
  };

  var lede = paras[0];
  var body = [], ing = [];
  paras.slice(1).forEach(function (p) {
    (isIng(p.text) ? ing : body).push(p);
  });
  // a product whose very first line is already the ingredient list
  if (!ing.length && isIng(lede.text)) { ing.push(lede); lede = null; }

  /* Pull display-worthy ingredient names out of the regulatory sentence:
     split on top-level commas/periods so "Confectionery (Sugar, Fennel)"
     stays one item, then drop the parenthetical detail and percentages. */
  function chipsFrom(text) {
    var t = text.replace(/^[\s\S]*?ingredients\s*:/i, '');
    t = t.split(/contains\s+permitted|contains\s+no|allergen|contains\s+nuts/i)[0];
    var out = [], depth = 0, cur = '';
    for (var i = 0; i < t.length; i++) {
      var c = t.charAt(i);
      if (c === '(') depth++;
      else if (c === ')') depth = Math.max(0, depth - 1);
      if ((c === ',' || c === '.') && depth === 0) { out.push(cur); cur = ''; }
      else cur += c;
    }
    out.push(cur);
    return out
      .map(function (s) {
        return s.replace(/\([^)]*\)/g, '')
                .replace(/\d+(\.\d+)?\s*%/g, '')
                .replace(/\s+/g, ' ')
                .replace(/^[\s.&-]+|[\s.&-]+$/g, '')
                .trim();
      })
      .filter(function (s) { return s.length > 1 && s.length < 40 && !/^\d+$/.test(s); })
      .map(function (s) { return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase(); })
      .filter(function (s, i, a) { return a.indexOf(s) === i; })
      .slice(0, 12);
  }

  /* The Shopify descriptions are now the canonical consumer copy. Keep the
     curated map for clean ingredient chips and as a fallback, but do not
     replace the fuller product story after page load. That way customers,
     search engines and no-JS visitors all receive the same useful copy. */
  var handle = (document.querySelector('[data-product-handle]') || {}).dataset;
  handle = handle ? handle.productHandle : '';
  var curated = (window.WELLUBIA_COPY || {})[handle];

  var chips = curated && curated.ing ? curated.ing
            : (ing.length ? chipsFrom(ing[0].text) : []);

  var children = [].slice.call(host.children);
  var ingEls = ing.map(function (p) { return p.el; });
  var ledeEl = lede ? lede.el : null;
  var bodyMarkup = children
    .filter(function (el) { return el !== ledeEl && ingEls.indexOf(el) === -1; })
    .map(function (el) {
      /* The five complete formula declarations are useful but too dense to
         leave open on a phone. Keep them in the page and make them optional. */
      if (handle === 'supreme-5-in-1' && el.tagName === 'P' && /the five blends/i.test(el.textContent || '')) {
        return '';
      }
      if (handle === 'supreme-5-in-1' && el.tagName === 'UL') {
        return '<details class="pd-blends"><summary>The five blends and their ingredients</summary>' +
          el.outerHTML + '</details>';
      }
      return el.outerHTML;
    })
    .join('');

  var html = '';
  if (ledeEl) {
    html += '<p class="pd-lede">' + ledeEl.innerHTML + '</p>';
  } else if (curated) {
    html += '<p class="pd-lede">' + curated.lede + '</p>';
  }
  if (bodyMarkup) {
    html += '<details class="pd-more"><summary>Product details</summary><div class="pd-body">' + bodyMarkup + '</div></details>';
  } else if (curated) {
    html += '<details class="pd-more"><summary>Product details</summary><div class="pd-body"><p>' + curated.prose + '</p></div></details>';
  }
  if (chips.length) {
    html += '<div class="pd-ing"><p class="pd-ing-label">What’s inside</p><ul class="pd-chips">' +
      chips.map(function (c) { return '<li>' + c + '</li>'; }).join('') +
      '</ul></div>';
  }
  if (ing.length) {
    html += '<details class="pd-legal"><summary>Full ingredient statement</summary>' +
      ing.map(function (p) { return '<p>' + p.el.innerHTML + '</p>'; }).join('') +
      '</details>';
  }

  if (html) {
    host.innerHTML = html;
    host.dataset.done = '1';
  }
})();
